// extracted by mini-css-extract-plugin
module.exports = {"Header":"Title_Header__-DAMh","Logo":"Title_Logo__HaPQO","Title":"Title_Title__evlYO","GitHubLink":"Title_GitHubLink__2-Ww6"};